import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const nameStyle = {
  width: '100%',
};

export const dateStyle = { width: '30%' };

export const timeStyle = {
  width: '20%',
};

export const iconTextField = { width: '100%' };

export const errorTextHelper = {
  backgroundColor: colors.BLUE_GRAY,
  margin: '0',
  paddingLeft: '0.5rem',
  paddingTop: '0.25rem',
};

export const iconTextArea = {
  background: colors.WHITE,
  width: '100%',
  fontSize: '1.5rem',
  borderRadius: '0.5rem',
  padding: '0.5rem',
};

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const DateOptions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const IconTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
`;

export default {
  FormContainer,
  DateContainer,
  DateOptions,
  IconTextContainer,
  nameStyle,
  dateStyle,
  timeStyle,
  iconTextField,
  iconTextArea,
  errorTextHelper,
};
